import React, { useCallback } from 'react';

import FilterSectionTitle, {
  FilterSectionTitleKind,
} from 'common/components/categories/FilterSectionTitle';
import type { ArticleSortOption } from 'common/enums/SortOption';
import { useAccordion } from 'common/hooks/accordion';
import { useLocalization } from 'common/providers/LocaleProvider';
import { trackToggleSortOptions } from 'common/tracking/filters';
import type { SortParams } from 'common/types/SortAndFilter';
import type { FilterChangeParams } from '../context/FilterDrawerContext';
import FilterAccordionSection from './FilterAccordionSection';
import SortSection from './SortSection';

interface SortAccordionProps extends SortParams {
  onFilterChange: (params: FilterChangeParams) => void;
  isSort?: boolean;
}

const SECTION_NAME = 'sorters';

const SortAccordion = ({
  order: activeSortOption,
  sortOptions,
  onFilterChange,
  isSort = false,
}: SortAccordionProps) => {
  const { t } = useLocalization();

  const [toggle, isExpanded] = useAccordion(
    isSort ? true : undefined,
    isSort ? [SECTION_NAME] : undefined
  );
  const trackToggle = (name: string) => {
    trackToggleSortOptions(isExpanded(name));
    toggle(name);
  };

  const onSortOptionChange = useCallback(
    (order: ArticleSortOption) => {
      onFilterChange({ order });
    },
    [onFilterChange]
  );

  return (
    <FilterAccordionSection
      title={
        <FilterSectionTitle
          kind={FilterSectionTitleKind.Sort}
          name={t('h24_sort_by')}
          order={activeSortOption}
          sortOptions={sortOptions}
        />
      }
      sectionKey={SECTION_NAME}
      isExpanded={isExpanded(SECTION_NAME)}
      onToggle={() => trackToggle(SECTION_NAME)}
    >
      <SortSection
        order={activeSortOption}
        sortOptions={sortOptions}
        onChange={onSortOptionChange}
      />
    </FilterAccordionSection>
  );
};

export default SortAccordion;
